import { render, staticRenderFns } from "./ResidActions.vue?vue&type=template&id=3b55d35c&scoped=true&"
import script from "./ResidActions.vue?vue&type=script&lang=js&"
export * from "./ResidActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b55d35c",
  null
  
)

export default component.exports